import React from 'react';

import Container from '../Container';

import ErrorCard from './ErrorCard';

const ErrorPage = () => (
  <Container>
    <ErrorCard />
  </Container>
);

export default ErrorPage;
